import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../shared/modal/modal";
import styles from "./modal-successful-create-krookie.module.scss";
import Button from "../../../../ui-kit/button/button";
import successIcon from "../../../../../images/success.svg";

interface ModalSuccessfulCreateKrookie {
  onClose: () => void;
  viewJournal: () => void;
  plotNumber: string;
}

const ModalSuccessfulCreateKrookie: FC<ModalSuccessfulCreateKrookie> = ({
  onClose,
  plotNumber,
  viewJournal,
}) => {
  const { t } = useTranslation();

  return (
    <Modal onClose={onClose}>
      <div className={styles.modalSuccessful}>
        <div className={styles.title}>
          {t("modalSuccessfulCreateKrookie.title")}
        </div>
        <div className={styles.body}>
          <img
            src={successIcon}
            alt={t("modalSuccessfulCreateKrookie.successAlt")}
          />
          <div className={styles.description}>
            {t("modalSuccessfulCreateKrookie.successMessage", { plotNumber })}
          </div>
          <Button onClick={viewJournal} className={styles.btn} type="primary">
            {t("modalSuccessfulCreateKrookie.viewJournalButton")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalSuccessfulCreateKrookie;
